import { MessageCircle } from 'lucide-react';

/**
 * Floating WhatsApp "Text us" button — fixed bottom-right on every page.
 */
const WhatsAppFab = () => {
  const phoneIntl = '447344414860';
  const message = encodeURIComponent(
    "Hi Maid for Cats! I'd like to ask about your cat sitting service."
  );
  const href = `https://wa.me/${phoneIntl}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Message us on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle size={26} aria-hidden="true" />
      <span className="whatsapp-fab-label">Text us</span>
    </a>
  );
};

export default WhatsAppFab;
